<template>
    <div class="tools-cards" :class="{ 'upgrade': view.is_available === false  }"
        v-on:mouseover="mouseover" v-on:mouseleave="mouseleave"
        @click="openTab(view.action_link)"
        data-toggle="tooltip" data-placement="bottom"
        :title="t.label_require_upgrade"
    >
        <div class="card-header">
            <div  class="card-title" v-html="view.title"></div>
        </div>
        <div class="separator"> </div>
        <div class="card-content">
            <div class="img-wrapper">
                <img class="icon" v-show="icon === 2" :alt="view.name" :src="`${view.image_link}`">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'start-a-project2',
    props: {
        view: { type: Object, },
        t: { type: Object, },
        data: { type: Object, },
        routes: null,
        is_free_plan: null,
    },
    data: function() {
        return {
            Description: true,
            icon: 2,
        }
    },
    mounted() {
        if (this.is_free_plan == true) {
            $('.tools-cards').tooltip('enable')
        } else {
            $('.tools-cards').tooltip('disable')
        }
    },
    methods: {
        LearnMore(button) {
            this.Description = button
        },
        mouseover: function(){
            this.icon = 2
        },
        mouseleave: function(){
            this.icon = 2
        },
        openTab(link){
            window.open(this.route_to_open(link), '_blank')
        },
        route_to_open(link) {
            if (this.is_free_plan == true) {
                return this.routes.rota_office_upgrade + '?is_free_plan=true'
            } else {
                return link
            }
        }
    }

}
</script>

<style lang="scss" scoped>
@import '../../../../scss/extras/_variables';

.tools-cards {
    font-family: "Muli";
    font-size: 10px; // base to em
    line-height: 1.2;


    background-color: $dv5-color4;
    border-radius: 0.8em;
    border: 1px transparent solid;
    box-sizing: border-box;

    min-height: 10em; // 100px
    width: 100%;
    min-height: 27.6em; // 276px
    transition: 0.4s;
    padding: 1.6em 0.8em;

    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: center;
    &:hover{
        border: 1px $dv5-color1 solid!important;
        cursor: pointer;
    }
    .card-header{
        //border: solid 1px red;
        width: 100%;
        font: inherit;
        height: 5.5em!important; // 40px

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .card-title{
            font: inherit;
            font-family: "Lato";
            font-size: 1.6em; // 1.6
            font-weight: 900;
            color: $dv5-color1;
            text-align: center;
            padding: 0 8%;
        }
    }
    .separator{
        opacity: 0.6;
        width: 80%;
        border-bottom: 1px #dfe7f2 solid;
    }
    .card-content{
        display: flex;
        justify-content: center;
        align-items: stretch;
        margin: 1em 0;
        img{
            width: 10.15625vw; // 195px  - image has box shadow
            min-width: 130px;
            height: auto;
        }
    }
}
@media screen and (max-width: 1199px) {
    .tools-cards {
        font-size: 8px;
    }
}
@media screen and (max-width: 360px) {
    .tools-cards {
        .card-content{
            img{
                width: 100%;
                padding: 0 1rem;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/start-a-project/StartaProjectCard2.vue